'use client';

import { useSession } from 'next-auth/react';

import NextLink from '@/components/next-link';
import AuthModal from '@/components/ui/modals/auth-modal';

import { sortJSONKeys } from '@/utils/global';
import { useState } from 'react';

const LinksList = ({ popularCategories, locale, knowUs, help }) => {
  const { data: session } = useSession();
  const [auth, setAuth] = useState(false);
  const sections = [
    { data: popularCategories, key: 'popularCategories' },
    { data: help, key: 'help' },
    { data: knowUs, key: 'knowUs' },
  ];

  // Normalize URLs for all sections
  sections.forEach(({ data }) => {
    const items = Array.isArray(data?.value) ? sortJSONKeys(data.value) : [];
    items.forEach((item) => {
      if (!item?.url) return;
      if (item?.url?.startsWith('static/')) {
        item.url = item?.url?.replace('static', '');
      } else if (!item?.url?.startsWith('/')) {
        item.url = `/${item?.url}`;
      }
    });
  });

  return (
    <>
      <div className='grid grid-cols-2 gap-5 border-b border-b-white/30 px-4 py-5 text-white lg:grid-cols-3 lg:gap-10 lg:px-10'>
        {sections.map(({ data, key }) => {
          const items = Array.isArray(data?.value)
            ? data?.value?.filter((item) => item?.active)
            : [];

          if (!items.length) return null;

          return (
            <div key={key} className='col-span-1'>
              <p className='mb-4 text-sm font-bold max-md:text-xs'>
                {data?.[`title-${locale}`] || ''}
              </p>
              <ul className='flex flex-col gap-4'>
                {items?.map((link, i) => {
                  const title = link?.[`title-${locale}`] || '';
                  const href = link?.url;
                  return (
                    <li
                      key={`${key}-${i}`}
                      className='text-sm uppercase max-md:text-xs'
                    >
                      {href && href !== '#' ? (
                        href?.startsWith('mailto:') ||
                        href?.startsWith('tel:') ? (
                          <a href={href}>{title}</a>
                        ) : href?.startsWith('/user') && !session ? (
                          <button
                            aria-label='Login'
                            onClick={() => setAuth('login-email')}
                            className='cursor-pointer text-xs font-semibold uppercase hover:underline'
                          >
                            {title}
                          </button>
                        ) : (
                          <NextLink href={href}>{title}</NextLink>
                        )
                      ) : (
                        <span>{title}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
      <AuthModal auth={auth} setAuth={setAuth} />
    </>
  );
};

export default LinksList;
